import { makeId } from "../utils";

export const Checkbox = ({
  label,
  children,
  isChecked = false,
  id = "checkbox_" + makeId(5),
  checkHandler = () => console.log("no fn assoc"),
}) => {
  return (
    <div className="checkbox-label">
      <input
        type="checkbox"
        id={id}
        checked={isChecked}
        onChange={(e) => checkHandler(e.target.checked)}
      />
      <label htmlFor={id} className="label">
        {children ? children : label}
      </label>
    </div>
  );
};
